module.exports = __webpack_public_path__ + "static/hotblack-tech-about1-1568622592fb75e14f3920cd8d754a1f.svg";